import request from '../../http/request'

export const getMerchantName = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/report/getMerchantNames`, params)
}

export const getDetailReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/report/detail-page`, params)
}

export const downloadDetailReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/report/detail-export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getTemplateList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/summary/report/templates`)
}

export const getSeasonList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/summary/report/seasons`)
}

export const getSummaryReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/summary/report/page`, params, {
    hiddenError: true
  })
}

export const downloadSummaryReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/summary/report/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
